let csrfName: string | null = null;
export const getCSRFName = (): string | null => {
  if (!csrfName) {
    const element = document.querySelector("meta[name='csrf-param']");
    if (element) {
      csrfName = element.getAttribute("content");
    }
  }

  return csrfName;
};

let csrfToken: string | null = null;
export const getCSRFToken = (): string | null => {
  if (!csrfToken) {
    const element = document.querySelector("meta[name='csrf-token']");
    if (element) {
      csrfToken = element.getAttribute("content");
    }
  }

  return csrfToken;
};

export const fetchPost = (url: string, params: object): Promise<Response> => {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
    redirect: "manual",
  });
};

export const fetchPostWithJson = <T>(url: string, params: object): Promise<T> => {
  return fetchPost(url, params).then(response => response.json());
};

export const fetchPostWithFormData = async (url: string, formData: FormData): Promise<Response> => {
  return fetch(url, {
    method: "POST",
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: formData,
    headers: {
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
    redirect: "manual",
  });
};

export const fetchGet = <T>(url: string): Promise<T> => {
  return fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "default",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Auth: "213455",
    },
  }).then(response => response.json());
};

export const fetchPatch = (url: string, params: object): Promise<Response> => {
  return fetch(url, {
    method: "PATCH",
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
  });
};

export const fetchPut = (url: string, params: object): Promise<Response> => {
  return fetch(url, {
    method: "PUT",
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
  });
};

export const fetchDelete = (url: string, params: object): Promise<Response> => {
  return fetch(url, {
    method: "DELETE",
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
  });
};

interface FetchWithMethodParams {
  url: string;
  method: string;
  params: object;
}

export const fetchWithMethod = ({
  url,
  method,
  params,
}: FetchWithMethodParams): Promise<Response> => {
  return fetch(url, {
    method,
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": getCSRFToken() || "",
    },
  });
};
